import {EventEmitter} from 'events'
import dispatcher from '../dispatcher/dispatcher'
import keys from '../keys'

class EmployeeStore extends EventEmitter{

    constructor(){
        super();
        this.loading = false
        this.employees=[]
    }

    fetchEmployees(){
        this.loading = true
        const url = keys.server + '/user/get-all-employees/'
        console.log("fetching data..")
        fetch(url,{
            method:"GET",
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization' : "token " + window.localStorage.token
            }
        })
        .then(response => {
            console.log(response)
            if(response.ok) {
                return response.json()
            }else{
                Error("request faild")
            }
        })
        .then(result =>{ 
                console.log(result)
                this.employees = result ;
                this.emit("update")
                this.loading = false
            
        })
        .catch(error => {console.log(error)})  
        this.loading = false
    }

    getEmployeeByNIC(NIC){
      const emp = this.employees.filter(
            (emp)=>{
            console.log(emp.NIC)
               return emp.NIC === NIC
            }
        )
    return emp
    }

    getEmployeeByID(id){
        console.log(id)
      const emp = this.employees.filter(
            (emp)=>{
               return emp.id === id
            }
        )
        console.log(emp)
    return emp
    }


    handleActions(action){
        console.log("Employee Store recieved an action" , action)
        switch(action.type){

            case "FETCH_EMPLOYEES":{
                this.fetchEmployees()
                break;
            }
            // case "UPDATE_CUSTOMERS":{
            //     this.updateCustomers()
            //     break;
            // }
            default:{
                console.log("Customer store recieved UNDEFINED action" , action)
            }

        }
    }
    
}

const employeeStore = new EmployeeStore()
dispatcher.register(employeeStore.handleActions.bind(employeeStore))
export default employeeStore;